import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const PaymentAPI = {
  savePaymentInformation: async (userId, paypalEmail, mpesaNumber) => {
    try {
      const response = await axiosInstance.post(Configs.savePaymentDetails, {
        user_id: userId,
        paypal_email: paypalEmail,
        mpesa_number: mpesaNumber,
      });

      if (response.data.status === "success") {
        console.log("Payment information saved successfully.");
        return response.data;
      } else {
        console.error(
          "Failed to save payment information:",
          response.data.data?.message
        );
        throw new Error(
          response.data.data?.message || "Unknown error occurred."
        );
      }
    } catch (error) {
      console.error("Error saving payment information:", error.message);
      throw error;
    }
  },

  // Starts a PayPal subscription payment for the logged-in user and returns
  // the PayPal approval URL to send them to. The backend prices the plan.
  createPaypalPayment: async (months) => {
    try {
      const response = await axiosInstance.post(Configs.paypalCreatePaymentEp, {
        months,
      });

      if (response.data.status === "success") {
        return response.data.data.message; // PayPal approval URL
      }
      throw new Error("Could not start PayPal payment.");
    } catch (error) {
      console.error("Error creating PayPal payment:", error.message);
      throw error;
    }
  },
};

export default PaymentAPI;
